/* eslint-disable no-duplicate-case */
import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialFeedState = {
  tableData: {},
  globalFeeds: [],
  availableFeeds: [],
  feeds: [],
  all_feeds: [],
  message: null,
  collection: null,
  status: STATUS.IDLE,
  feedsLoadStatus: STATUS.IDLE,
  globalFeedsStatus: STATUS.IDLE,
  consumeStatus: STATUS.IDLE,
  saveStatus: STATUS.IDLE,
  testStatus: STATUS.IDLE,
  activateStatus: STATUS.IDLE,
};

export default (state = initialFeedState, action) => {
  switch (action?.type) {
    case types.RESET_FEED_STATUS:
      return {
        ...state,
        globalFeedsStatus: STATUS.IDLE,
        consumeStatus: STATUS.IDLE,
        saveStatus: STATUS.IDLE,
        testStatus: STATUS.IDLE,
        message: null,
        collection: null,
        error: false,
        tableData: {},
      };
    case types.LOAD_GLOBAL_FEEDS: {
      return {
        ...state,
        globalFeedsStatus: STATUS.LOADING,
        globalFeeds: [],
      };
    }
    case resolve(types.LOAD_GLOBAL_FEEDS): {
      return {
        ...state,
        globalFeeds: action?.payload,
        globalFeedsStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_FEEDS_GLOBAL: {
      return {
        ...state,
        globalFeedsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_FEEDS_GLOBAL): {
      return {
        ...state,
        sources: action?.payload,
        globalFeedsStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_NEW_FEEDS_GLOBAL: {
      return {
        ...state,
        newGlobalFeedsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_NEW_FEEDS_GLOBAL): {
      return {
        ...state,
        sources: action?.payload,
        newGlobalFeedsStatus: STATUS.LOADED,
      };
    }

    case types.CONSUME_FEED_DATA: {
      return {
        ...state,
        consumeStatus: STATUS.LOADING,
        message: null,
      };
    }
    case resolve(types.CONSUME_FEED_DATA):
      return {
        ...state,
        consumeStatus: STATUS.LOADED,
        tableData: action?.payload,
      };
    case reject(types.CONSUME_FEED_DATA):
      return {
        ...state,
        error: true,
        consumeStatus: STATUS.ERROR,
      };
    case types.CONSUME_FILE_DATA: {
      return {
        ...state,
        consumeStatus: STATUS.LOADING,
        message: null,
      };
    }
    case resolve(types.CONSUME_FILE_DATA):
      return {
        ...state,
        consumeStatus: STATUS.LOADED,
        tableData: action?.payload,
      };
    case reject(types.CONSUME_FILE_DATA):
      return {
        ...state,
        error: true,
        consumeStatus: STATUS.ERROR,
      };
    case types.CREATE_VIRTUAL_FEED: {
      return {
        ...state,
        saveStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.CREATE_VIRTUAL_FEED): {
      // console.log(action?.payload);
      const { feeds } = state;
      return {
        ...state,
        feeds: [action?.payload, ...feeds],
      };
    }
    case reject(types.CREATE_VIRTUAL_FEED):
      return {
        ...state,
        message: action?.message,
        saveStatus: STATUS.ERROR,
      };
    case types.UPDATE_VIRTUAL_FEED: {
      return {
        ...state,
        saveStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.UPDATE_VIRTUAL_FEED): {
      const { feeds } = state;
      const index = feeds?.findIndex((f) => f?.uuid === action?.payload?.uuid);
      return {
        ...state,
        feeds: [
          ...feeds?.slice(0, index),
          action?.payload,
          ...feeds?.slice(index + 1),
        ],
      };
    }
    case reject(types.UPDATE_VIRTUAL_FEED):
      return {
        ...state,
        message: action?.message,
        saveStatus: STATUS.ERROR,
      };
    case types.VERIFY_FEED_AUTH: {
      return {
        ...state,
        testStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.VERIFY_FEED_AUTH):
      return {
        ...state,
        message: action?.message,
        testStatus: STATUS.SUCCESS,
      };
    case reject(types.VERIFY_FEED_AUTH):
      return {
        ...state,
        message: action?.message,
        testStatus: STATUS.ERROR,
      };
    case types.CREATE_GLOBAL_FEED:
    case types.UPDATE_GLOBAL_FEED: {
      return {
        ...state,
        saveStatus: STATUS.RUNNING,
      };
    }
    case resolve(types.CREATE_GLOBAL_FEED): {
      return {
        ...state,
        globalFeeds: state?.globalFeeds?.concat(action?.payload),
        saveStatus: STATUS.SUCCESS,
        message: null,
      };
    }
    case resolve(types.DELETE_GLOBAL_FEED): {
      return {
        ...state,
        globalFeeds: state?.globalFeeds?.filter((f) => f?.uuid !== action.uuid),
      };
    }
    case resolve(types.UPDATE_GLOBAL_FEED): {
      const { globalFeeds } = state;
      const index = globalFeeds?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      return {
        ...state,
        globalFeeds: [
          ...globalFeeds?.slice(0, index),
          action?.payload,
          ...globalFeeds?.slice(index + 1),
        ],
        saveStatus: STATUS.SUCCESS,
        message: null,
      };
    }
    case reject(types.CREATE_GLOBAL_FEED):
    case reject(types.UPDATE_GLOBAL_FEED):
      return {
        ...state,
        message: action?.message,
        saveStatus: STATUS.ERROR,
      };

    case types.SIMPLE_ADD_FEED: {
      return {
        ...state,
        feeds: [...state?.feeds, {}],
      };
    }
    case types.DELETE_EMPTY_FEED: {
      let newFeeds = [...state?.feeds];
      newFeeds.pop();
      return {
        ...state,
        feeds: newFeeds,
      };
    }

    case resolve(types.DELETE_COLLECTION): {
      // console.log(action);
      return {
        ...state,
        collections: state?.collections?.filter(
          (f) => f?.uuid !== action?.uuid,
        ),
      };
    }

    case types.LOAD_FEED_PERFORMANCE: {
      return {
        ...state,
        feedsLoadStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_FEED_PERFORMANCE): {
      return {
        ...state,
        feeds: action?.payload,
        feedsLoadStatus: STATUS.LOADED,
      };
    }

    case resolve(types.CLEAR_SOURCES_REPORTS): {
      return {
        ...state,
        sourcesReport: [],
        sourcesReportStatus: STATUS.IDLE,
        sourcesReportOverlapOriginator: [],
      };
    }

    case types.LOAD_SOURCES_REPORTS: {
      return {
        ...state,
        sourcesReportStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_SOURCES_REPORTS): {
      return {
        ...state,
        sourcesReport: action?.payload,
        sourcesReportStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_SOURCE_REPORT: {
      return {
        ...state,
      };
    }
    case resolve(types.LOAD_SOURCE_REPORT): {
      const { sourcesReport } = state;
      const index = sourcesReport?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      let newSourcesReport = sourcesReport;
      if (index !== -1) {
        let sourceReport = sourcesReport[index];
        if (sourceReport) {
          sourceReport['originator_explain'] =
            action?.payload?.originator_explain;
          sourceReport['originator_score'] = action?.payload?.originator_score;
          sourceReport['overlap_explain'] = action?.payload?.overlap_explain;
          sourceReport['overlap_score'] = action?.payload?.overlap_score;
        }
        newSourcesReport = [
          ...sourcesReport?.slice(0, index),
          sourceReport,
          ...sourcesReport?.slice(index + 1),
        ];
      }
      return {
        ...state,
        sourcesReportWithOverlapOriginator: newSourcesReport,
      };
    }

    case types.LOAD_NEW_FEEDS: {
      return {
        ...state,
        newFeedsLoadStatus: STATUS.LOADING,
      };
    }
    case types.LOAD_NEW_ORGANIZATION_FEEDS: {
      return {
        ...state,
        newOrganizationFeedsLoadStatus: STATUS.LOADING,
      };
    }
    case types.LOAD_NEW_MY_FEEDS: {
      return {
        ...state,
        newMyFeedsLoadStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_NEW_FEEDS): {
      return {
        ...state,
        new_feeds: action?.payload,
        newFeedsLoadStatus: STATUS.LOADED,
      };
    }
    case resolve(types.LOAD_NEW_ORGANIZATION_FEEDS): {
      return {
        ...state,
        new_organization_feeds: action?.payload,
        newOrganizationFeedsLoadStatus: STATUS.LOADED,
      };
    }
    case resolve(types.LOAD_NEW_MY_FEEDS): {
      return {
        ...state,
        new_my_feeds: action?.payload,
        newMyFeedsLoadStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_FEEDS: {
      return {
        ...state,
        feedsLoadStatus: STATUS.LOADING,
      };
    }
    case types.LOAD_ORGANIZATION_FEEDS: {
      return {
        ...state,
        organizationFeedsLoadStatus: STATUS.LOADING,
      };
    }
    case types.LOAD_MY_FEEDS: {
      return {
        ...state,
        myFeedsLoadStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_FEEDS): {
      return {
        ...state,
        feeds: action?.payload,
        feedsLoadStatus: STATUS.LOADED,
      };
    }
    case resolve(types.LOAD_ORGANIZATION_FEEDS): {
      return {
        ...state,
        organization_feeds: action?.payload,
        organizationFeedsLoadStatus: STATUS.LOADED,
      };
    }
    case resolve(types.LOAD_MY_FEEDS): {
      return {
        ...state,
        my_feeds: action?.payload,
        myFeedsLoadStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_COLLECTIONS:
    case types.LOAD_ORGANIZATION_COLLECTIONS:
    case types.LOAD_MY_COLLECTIONS: {
      return {
        ...state,
        collectionsLoadStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_COLLECTIONS):
    case resolve(types.LOAD_ORGANIZATION_COLLECTIONS):
    case resolve(types.LOAD_MY_COLLECTIONS): {
      return {
        ...state,
        collections: action?.payload,
        collectionsLoadStatus: STATUS.LOADED,
      };
    }

    case types.ACTIVATE_COLLECTION: {
      return {
        ...state,
        activateStatus: STATUS.LOADING,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.ACTIVATE_COLLECTION): {
      const { collections } = state;
      const index = collections?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      let updatedCollection = Object.assign({}, collections[index]);
      updatedCollection = {
        ...updatedCollection,
        is_active: action?.payload?.is_active,
      };

      return {
        ...state,
        collections: [
          ...collections?.slice(0, index),
          updatedCollection,
          ...collections?.slice(index + 1),
        ],
        activateStatus: STATUS.LOADED,
        status: STATUS.LOADED,
      };
    }

    case types.ACTIVATE_FEED: {
      return {
        ...state,
        activateStatus: STATUS.LOADING,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.ACTIVATE_FEED): {
      const { feeds, sources } = state;

      const feeds_index = feeds?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      let updatedFeed = Object.assign({}, feeds[feeds_index]);
      updatedFeed = { ...updatedFeed, is_active: action?.payload?.is_active };

      const globalfeeds_index = sources?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );

      let updatedGlobalFeed = null;

      if (sources) {
        updatedGlobalFeed = Object.assign({}, sources[globalfeeds_index]);
        updatedGlobalFeed = {
          ...updatedGlobalFeed,
          is_active: action?.payload?.is_active,
        };
      }

      let new_state = {
        ...state,
        feeds: [
          ...feeds?.slice(0, feeds_index),
          updatedFeed,
          ...feeds?.slice(feeds_index + 1),
        ],
        activateStatus: STATUS.LOADED,
        status: STATUS.LOADED,
      };

      if (sources) {
        new_state = {
          ...new_state,
          sources: [
            ...sources?.slice(0, globalfeeds_index),
            updatedGlobalFeed,
            ...sources?.slice(globalfeeds_index + 1),
          ],
        };
      }

      return new_state;
    }

    case resolve(types.PUBLISH_COLLECTION): {
      return {
        ...state,
        collections: state?.collections?.filter(
          (f) => f?.uuid !== action?.uuid,
        ),
      };
    }

    case types.ACTIVATE_MY_FEED: {
      return {
        ...state,
        activateStatus: STATUS.LOADING,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.ACTIVATE_MY_FEED): {
      const { my_feeds } = state;
      const index = my_feeds?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      let updatedFeed = Object.assign({}, my_feeds[index]);
      updatedFeed = { ...updatedFeed, is_active: action?.payload?.is_active };
      // updatedFeed = {...updatedFeed, is_active: true}

      return {
        ...state,
        my_feeds: [
          ...my_feeds?.slice(0, index),
          updatedFeed,
          ...my_feeds?.slice(index + 1),
        ],
        activateStatus: STATUS.LOADED,
        status: STATUS.LOADED,
      };
    }

    case types.ACTIVATE_ORGANIZATION_FEED: {
      return {
        ...state,
        activateStatus: STATUS.LOADING,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.ACTIVATE_ORGANIZATION_FEED): {
      const { organization_feeds } = state;
      const index = organization_feeds?.findIndex(
        (f) => f?.uuid === action?.payload?.uuid,
      );
      let updatedFeed = Object.assign({}, organization_feeds[index]);
      updatedFeed = { ...updatedFeed, is_active: action?.payload?.is_active };

      return {
        ...state,
        organization_feeds: [
          ...organization_feeds?.slice(0, index),
          updatedFeed,
          ...organization_feeds?.slice(index + 1),
        ],
        activateStatus: STATUS.LOADED,
        status: STATUS.LOADED,
      };
    }

    case types.UPLOAD_TO_COLLECTION: {
      return {
        ...state,
        status: STATUS.LOADING,
      };
    }

    case resolve(types.CHANGE_SCOPE_COLLECTION): {
      return {
        ...state,
        status: STATUS.LOADED,
      };
    }

    case types.LOAD_COLLECTION: {
      return {
        ...state,
        collectionLoadStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_COLLECTION): {
      // console.log(action);
      return {
        ...state,
        collection: action?.payload,
        collectionLoadStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_ALL_FEEDS: {
      return {
        ...state,
        allFeedLoadStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_ALL_FEEDS): {
      return {
        ...state,
        all_feeds: action?.payload,
        allFeedLoadStatus: STATUS.LOADED,
      };
    }

    case types.SAVE_EMPTY_COLLECTION: {
      return {
        ...state,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.SAVE_EMPTY_COLLECTION): {
      // console.log(action);
      const { all_feeds, collections, feeds, my_feeds } = state;

      let new_state = {};

      if (action.payload.state === 'COLLECTION') {
        new_state = {
          ...state,
          collections: [action?.payload, ...collections],
          all_feeds: [action?.payload, ...all_feeds],
          status: STATUS.LOADED,
        };
      } else {
        new_state = {
          ...state,
          status: STATUS.LOADED,
        };
        if (all_feeds !== undefined) {
          new_state = {
            ...new_state,
            all_feeds: [action?.payload, ...all_feeds],
          };
        }
        if (feeds !== undefined) {
          new_state = {
            ...new_state,
            feeds: [action?.payload, ...feeds],
          };
        }
        if (my_feeds !== undefined) {
          new_state = {
            ...new_state,
            my_feeds: [action?.payload, ...my_feeds],
          };
        }
      }
      return new_state;
    }

    case types.CREATE_COLLECTION_BY_FILE_UPLOAD: {
      return {
        ...state,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_COLLECTION_BY_FILE_UPLOAD): {
      return {
        ...state,
        status: STATUS.LOADED,
      };
    }

    case types.CREATE_COLLECTION_BY_URL_UPLOAD: {
      return {
        ...state,
        status: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_COLLECTION_BY_URL_UPLOAD): {
      return {
        ...state,
        status: STATUS.LOADED,
      };
    }

    case resolve(types.UPDATE_COLLECTION): {
      return {
        ...state,
        status: STATUS.LOADED,
      };
    }

    case resolve(types.UPLOAD_TO_COLLECTION): {
      return {
        ...state,
        status: STATUS.LOADED,
      };
    }

    case resolve(types.UPDATE_FEED): {
      const { feeds } = state;
      const index = feeds?.findIndex((f) => f?.uuid === action?.payload?.uuid);
      return {
        ...state,
        feeds: [
          ...feeds?.slice(0, index),
          action?.payload,
          ...feeds?.slice(index + 1),
        ],
      };
    }
    case resolve(types.CREATE_FEED): {
      const { feeds } = state;
      return {
        ...state,
        feeds: [action?.payload, ...feeds],
      };
    }
    case resolve(types.DELETE_FEED): {
      return {
        ...state,
        feeds: state?.feeds?.filter((f) => f?.uuid !== action?.uuid),
      };
    }
    case resolve(types.DELETE_ORGANIZATION_FEED): {
      return {
        ...state,
        organization_feeds: state?.organization_feeds?.filter(
          (f) => f?.uuid !== action?.uuid,
        ),
      };
    }
    case resolve(types.DELETE_MY_FEED): {
      return {
        ...state,
        my_feeds: state?.my_feeds?.filter((f) => f?.uuid !== action?.uuid),
      };
    }

    case types.LOAD_AVAILABLE_FEEDS: {
      return {
        ...state,
        globalFeedsStatus: STATUS.LOADING,
        availableFeeds: [],
      };
    }
    case resolve(types.LOAD_AVAILABLE_FEEDS): {
      return {
        ...state,
        availableFeeds: action?.payload,
        globalFeedsStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_IP_EDITABLE_FEEDS: {
      return {
        ...state,
        IPEditableFeedsStatus: STATUS.LOADING,
        IPEditableFeeds: [],
      };
    }
    case resolve(types.LOAD_IP_EDITABLE_FEEDS): {
      return {
        ...state,
        IPEditableFeedsStatus: STATUS.LOADED,
        IPEditableFeeds: action?.payload,
      };
    }

    case types.LOAD_DOMAIN_EDITABLE_FEEDS: {
      return {
        ...state,
        DomainEditableFeedsStatus: STATUS.LOADING,
        DomainEditableFeeds: [],
      };
    }
    case resolve(types.LOAD_DOMAIN_EDITABLE_FEEDS): {
      return {
        ...state,
        DomainEditableFeedsStatus: STATUS.LOADED,
        DomainEditableFeeds: action?.payload,
      };
    }

    case types.LOAD_URL_EDITABLE_FEEDS: {
      return {
        ...state,
        URLEditableFeedsStatus: STATUS.LOADING,
        URLEditableFeeds: [],
      };
    }
    case resolve(types.LOAD_URL_EDITABLE_FEEDS): {
      return {
        ...state,
        URLEditableFeedsStatus: STATUS.LOADED,
        URLEditableFeeds: action?.payload,
      };
    }

    default:
      return state;
  }
};
